import React from 'react'
import css from './UserList.module.css'
import UserListItem from '../../atoms/UserListItem/UserListItem'
import usePeopleManagement from '../../../hooks/usePeopleManagement'
import { GymMemberData } from '../../../types/types'
import { trackedAtMs } from '../../../utilities/memberDates'

type Props = {
  data: GymMemberData[]
  onUserAction: (action: string, data: GymMemberData) => void
  /** From useGymEngagement. Undefined when not loaded or not permitted */
  lastOpenedAt?: { [uid: string]: number | null } | null
  /** Rows show a placeholder for dates, except rows whose view is in
   * `lastOpenedAt` already */
  activityIsLoading?: boolean
  /** Render `data` in the given order instead of sorting by last activity */
  keepOrder?: boolean
  /** Number of the first row, so numbering continues across grouped lists */
  startIndex?: number
}

const UserList = ({
  data,
  onUserAction,
  lastOpenedAt,
  activityIsLoading,
  keepOrder = false,
  startIndex = 1,
}: Props) => {
  return (
    <div className={`${css['user-list']}`}>
      <ul>
        {data &&
          (keepOrder ? data : sortByActivity(data)).map((item, index) => {
            return (
              item?.uid && (
                <UserListItem
                  data={item}
                  key={item.uid}
                  onUserAction={onUserAction}
                  index={index + startIndex}
                  activityIsLoading={
                    activityIsLoading &&
                    !(lastOpenedAt && item.uid in lastOpenedAt)
                  }
                  lastOpenedAt={
                    lastOpenedAt ? lastOpenedAt[item.uid] ?? null : undefined
                  }
                />
              )
            )
          })}
      </ul>
    </div>
  )
}

/** Default order: newest tracked first, then by name. Doesn't mutate `data` */
const sortByActivity = (data: GymMemberData[]) =>
  [...data]
    .sort((a, b) => {
      if (a.name && b.name) {
        return a.name.localeCompare(b.name)
      } else if (a.name) {
        return -1
      } else if (b.name) {
        return 1
      } else {
        return 0
      }
    })
    // Never tracked (0) goes last; ties keep the name order (stable sort)
    .sort((a, b) => trackedAtMs(b) - trackedAtMs(a))

export default UserList
